/***********************************************************
Cart Drawer Logic
***********************************************************/
function initCartDrawer() {
  const cartBtn = document.getElementById('cart-button');
  const cartDrawer = document.getElementById('cart-drawer');
  const cartClose = document.getElementById('cart-drawer-close');
  const cartOverlay = document.querySelector('.cart-drawer__overlay');

  function openCartDrawer() {
    cartDrawer?.classList.add('open');
    document.body.classList.add('no-scroll');
  }

  function closeCartDrawer() {
    cartDrawer?.classList.remove('open');
    document.body.classList.remove('no-scroll');
  }

  cartBtn?.addEventListener('click', openCartDrawer);
  cartClose?.addEventListener('click', closeCartDrawer);
  cartOverlay?.addEventListener('click', closeCartDrawer);

  // Expose globally
  window.openCartDrawer = openCartDrawer;
  window.refreshCartDrawer = refreshCartDrawer;
  window.refreshCartPage = refreshCartPage;

  // Delegate Remove Button Handling (drawer + page share selectors)
  document.addEventListener('click', (e) => {
    if (e.target.matches('[data-remove-item]')) {
      e.preventDefault();
      const line = parseInt(e.target.getAttribute('data-remove-item'), 10);
      if (!line) return;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line, quantity: 0 }),
      })
      .then(refreshCartDrawer)
      .then(refreshCartPage)
      .then(updateCartItemCount)
      .catch(err => console.error('Remove item error:', err));
    }
  });

  // Delegate Quantity Button Handling (works for both drawer + page)
  document.addEventListener('click', (e) => {
    const increaseBtn = e.target.closest('.cart-drawer__product-quantity-increase');
    const decreaseBtn = e.target.closest('.cart-drawer__product-quantity-decrease');
    if (!increaseBtn && !decreaseBtn) return;

    const wrapper = e.target.closest('.cart-drawer__product-quantity-actions');
    const line = parseInt(wrapper?.dataset.line, 10);
    const currentQty = parseInt(wrapper?.dataset.currentQty, 10);
    if (!line || isNaN(currentQty)) return;

    let newQty = currentQty + (increaseBtn ? 1 : -1);

    // Remove if qty < 1, else update
    const payload = newQty < 1 ? { line, quantity: 0 } : { line, quantity: newQty };

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload),
    })
    .then(refreshCartDrawer)
    .then(refreshCartPage)
    .then(updateCartItemCount)
    .catch(err => console.error('Quantity update error:', err));
  });
}

/***********************************************************
Refresh Cart Drawer (Section Rendering API)
***********************************************************/
function refreshCartDrawer() {
  return fetch('/?section_id=cart-drawer')
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newDrawer = doc.querySelector('#cart-drawer');
      const existingDrawer = document.querySelector('#cart-drawer');
      if (newDrawer && existingDrawer) {
        existingDrawer.innerHTML = newDrawer.innerHTML;

        // Rebind close + overlay
        const cartClose = document.getElementById('cart-drawer-close');
        const cartOverlay = document.querySelector('.cart-drawer__overlay');
        cartClose?.addEventListener('click', () => {
          existingDrawer.classList.remove('open');
          document.body.classList.remove('no-scroll');
        });
        cartOverlay?.addEventListener('click', () => {
          existingDrawer.classList.remove('open');
          document.body.classList.remove('no-scroll');
        });
      }
    })
    .catch(err => console.error('Cart drawer refresh error:', err));
}

/***********************************************************
Refresh Cart Page (Section Rendering API)
***********************************************************/
function refreshCartPage() {
  const cartPage = document.querySelector('[data-cart-page]');
  if (!cartPage) return Promise.resolve(); // not on cart page

  const sectionId = cartPage.getAttribute('data-section-id');
  if (!sectionId) {
    console.warn('Missing data-section-id on cart page container');
    return Promise.resolve();
  }

  return fetch(`/?section_id=${encodeURIComponent(sectionId)}`)
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      // Grab the fresh cart block from the response
      const fresh = doc.querySelector('[data-cart-page]');
      if (fresh) {
        cartPage.innerHTML = fresh.innerHTML;
      }
    })
    .catch(err => console.error('Cart page refresh error:', err));
}

/***********************************************************
AJAX Add-to-Cart + Refresh Drawer (+ Page)
***********************************************************/
function initAddToCart() {
  const form = document.querySelector('.button__cta-form');
  const variantInput = document.getElementById('selected-variant-id');
  if (!form || !variantInput) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    const formData = { id: variantInput.value, quantity: 1 };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(formData),
    })
    .then(res => {
      if (!res.ok) throw new Error('Add to cart failed');
      return res.json();
    })
    .then(() => refreshCartDrawer())
    .then(() => refreshCartPage()) // in case user is on /cart
    .then(updateCartItemCount)
    .then(() => { if (window.openCartDrawer) window.openCartDrawer(); })
    .catch(err => console.error('Error adding to cart:', err));
  });
}

/***********************************************************
Update Cart Number
***********************************************************/
function updateCartItemCount() {
  return fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const count = cart.item_count || 0;
      const countEl = document.querySelector('.cart-container__number');
      const countCartEl = document.querySelector('.cart-drawer__count');
      if (countEl) countEl.textContent = count;
      if (countCartEl) countCartEl.textContent = count;
    })
    .catch(err => console.error('Cart count update failed:', err));
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  initCartDrawer();
  initAddToCart();
});
